export default __webpack_public_path__ + "static/task5-b3ce1fa1243ac692a13cc47aa4d90944.png";